module.exports = __webpack_public_path__ + "static/media/PricingPlans.d44970c9.svg";